"use client";

import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import "./VoiceBot.css";

import audioFr from "./medilink_fr.mp3";
import audioEn from "./medilink_en.mp3";
import audioAr from "./medilink_ar.mp3";

const AUDIO_MAP = {
  fr: audioFr,
  en: audioEn,
  ar: audioAr,
};

// ─── Clé localStorage ─────────────────────────────────────────────────────────
const MUTED_KEY = "medilink_voice_user_muted";

// ─── Icône Micro SVG ─────────────────────────────────────────────────────────
function MicIcon({ active }) {
  const c = active
    ? {
        outer:   "#93D2FF",
        bodyTop: "#93D2FF",
        bodyBot: "#1e1e1e",
        bodyBot2:"#1a5fd4",
        base:    "#1e1e1e",
        base2:   "#1a5fd4",
        dot:     "#FF7919",
        dot2:    "#E64545",
        eye1:    "#1e1e1e",
        eye2:    "#001F34",
        eye3:    "#001F34",
        eye4:    "#1e1e1e",
      }
    : {
        outer:   "#2a3050",
        bodyTop: "#1e2540",
        bodyBot: "#111828",
        bodyBot2:"#0d1220",
        base:    "#111828",
        base2:   "#0a0f1a",
        dot:     "#2a3050",
        dot2:    "#1a2040",
        eye1:    "#1a2040",
        eye2:    "#0d1220",
        eye3:    "#0d1220",
        eye4:    "#1a2040",
      };

  return (
    <svg
      width="28" height="28"
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transition: "all 0.4s ease", display: "block" }}
    >
      <g clipPath="url(#clip0_mute)">
        <path d="M40.4414 24.0059H35.959C35.1338 24.0059 34.4648 24.6748 34.4648 25.5C34.4648 26.3252 35.1338 26.9941 35.959 26.9941H38.9473V28.3405C38.9473 35.7613 32.9982 41.8933 25.5775 41.9353C18.1268 41.9775 12.0527 35.9293 12.0527 28.4883V26.9941H15.041C15.8662 26.9941 16.5352 26.3252 16.5352 25.5C16.5352 24.6748 15.8662 24.0059 15.041 24.0059H10.5586C9.73343 24.0059 9.06445 24.6748 9.06445 25.5V28.4883C9.06445 37.0464 15.6429 44.0896 24.0059 44.8481V49.4642C24.0059 50.2693 24.6251 50.9615 25.4293 50.9984C26.2874 51.0379 26.9941 50.3551 26.9941 49.5059V44.8481C35.3571 44.0896 41.9355 37.0464 41.9355 28.4883V25.5C41.9355 24.6748 41.2666 24.0059 40.4414 24.0059Z" fill={c.outer}/>
        <path d="M40.4414 24.0059H35.959C35.1338 24.0059 34.4648 24.6748 34.4648 25.5C34.4648 26.3252 35.1338 26.9941 35.959 26.9941H38.9473V28.4883C38.9473 35.9035 32.9152 41.9355 25.5 41.9355V51C26.3259 51 26.9941 50.3317 26.9941 49.5059V44.8481C35.3571 44.0896 41.9355 37.0464 41.9355 28.4883V25.5C41.9355 24.6748 41.2666 24.0059 40.4414 24.0059Z" fill={c.outer}/>
        <path d="M35.959 24.0058V10.5741C35.959 4.80335 31.3335 0.0342524 25.5629 0.000185957C19.7677 -0.0340797 15.041 4.67157 15.041 10.459V24.0058C15.041 24.831 15.71 25.5 16.5352 25.5H34.4648C35.29 25.5 35.959 24.831 35.959 24.0058Z" fill={c.bodyTop}/>
        <path d="M34.4648 25.5C35.29 25.5 35.959 24.831 35.959 24.0059V10.459C35.959 4.6925 31.2665 0 25.5 0V25.5H34.4648Z" fill={c.bodyTop}/>
        <path d="M15.041 24.0059V28.4883C15.041 34.2548 19.7335 38.9473 25.5 38.9473C31.2665 38.9473 35.959 34.2548 35.959 28.4883V24.0059H15.041Z" fill={c.bodyBot}/>
        <path d="M25.5 24.0059V38.9473C31.2665 38.9473 35.959 34.2548 35.959 28.4883V24.0059H25.5Z" fill={c.bodyBot2}/>
        <path d="M34.4648 51H16.5352C15.7093 51 15.041 50.3317 15.041 49.5059C15.041 48.68 15.7093 48.0117 16.5352 48.0117H34.4648C35.2907 48.0117 35.959 48.68 35.959 49.5059C35.959 50.3317 35.2907 51 34.4648 51Z" fill={c.base}/>
        <path d="M34.4648 48.0117H25.5V51H34.4648C35.2907 51 35.959 50.3317 35.959 49.5059C35.959 48.68 35.2907 48.0117 34.4648 48.0117Z" fill={c.base2}/>
        <path d="M25.5 32.9707C26.3252 32.9707 26.9941 32.3018 26.9941 31.4766C26.9941 30.6514 26.3252 29.9824 25.5 29.9824C24.6748 29.9824 24.0059 30.6514 24.0059 31.4766C24.0059 32.3018 24.6748 32.9707 25.5 32.9707Z" fill={c.dot}/>
        <path d="M26.9941 31.4766C26.9941 30.6512 26.3252 29.9824 25.5 29.9824V32.9707C26.3252 32.9707 26.9941 32.3017 26.9941 31.4766Z" fill={c.dot2}/>
        <circle cx="22.5117" cy="16.4355" r="2.9883" fill={c.eye1}/>
        <circle cx="28.4883" cy="16.4355" r="2.9883" fill={c.eye2}/>
        <circle cx="28.4883" cy="10.459"  r="2.9883" fill={c.eye3}/>
        <circle cx="22.5117" cy="10.459"  r="2.9883" fill={c.eye4}/>
      </g>
      <defs>
        <clipPath id="clip0_mute">
          <rect width="51" height="51" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
}

export default function VoiceBot() {
  const { i18n } = useTranslation();
  const audioRef    = useRef(null);
  const firstLoadRef = useRef(false);

  // Initialiser isMuted depuis localStorage dès le départ
  const [isMuted, setIsMuted] = useState(
    () => localStorage.getItem(MUTED_KEY) === "true"
  );
  const [isPlaying, setIsPlaying] = useState(false);

  // ─── Helpers ──────────────────────────────────────────────────────────────
  const getCurrentLanguage = () => {
    const lang =
      i18n.language ||
      localStorage.getItem("i18nextLng") ||
      document.documentElement.lang ||
      "fr";
    const normalized = String(lang).toLowerCase();
    if (normalized.startsWith("ar")) return "ar";
    if (normalized.startsWith("en")) return "en";
    return "fr";
  };

  const stopAudio = () => {
    if (!audioRef.current) return;
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
    setIsPlaying(false);
  };

  const playLanguageAudio = async () => {
    const lang = getCurrentLanguage();
    const src  = AUDIO_MAP[lang];
    stopAudio();
    const audio    = new Audio(src);
    audio.volume   = 1;
    audio.muted    = localStorage.getItem(MUTED_KEY) === "true"; // toujours lire depuis localStorage
    audio.onplay   = () => setIsPlaying(true);
    audio.onended  = () => setIsPlaying(false);
    audio.onerror  = () => setIsPlaying(false);
    audioRef.current = audio;
    await audio.play(); // laisser remonter l'erreur si autoplay bloqué
  };

  // ─── Toggle mute : persiste dans localStorage ─────────────────────────────
  const toggleMute = () => {
    const nextMuted = !isMuted;
    setIsMuted(nextMuted);

    if (audioRef.current) audioRef.current.muted = nextMuted;

    if (nextMuted) {
      // L'utilisateur coupe → mémoriser pour tous les futurs rechargements
      localStorage.setItem(MUTED_KEY, "true");
    } else {
      // L'utilisateur réactive → effacer la préférence
      localStorage.removeItem(MUTED_KEY);
    }
  };

  // ─── AUTO PLAY SMART ──────────────────────────────────────────────────────
  useEffect(() => {
    // Si l'utilisateur a déjà coupé manuellement → ne JAMAIS relancer
    const userHasMuted = localStorage.getItem(MUTED_KEY) === "true";
    if (userHasMuted) {
      firstLoadRef.current = true; // marquer comme initialisé quand même
      return;
    }

    const startVoice = async () => {
      if (firstLoadRef.current) return;
      firstLoadRef.current = true;

      try {
        await playLanguageAudio();
      } catch (error) {
        // Autoplay bloqué par le navigateur → attendre un geste utilisateur
        console.warn("Autoplay blocked, waiting for user interaction...");

        const unlockAudio = async () => {
          try {
            // Vérifier à nouveau : l'user n'a pas coupé entre-temps
            if (localStorage.getItem(MUTED_KEY) === "true") return;
            await playLanguageAudio();
          } catch (e) {
            console.warn("Still blocked:", e);
          }
        };

        window.addEventListener("click",      unlockAudio, { once: true });
        window.addEventListener("touchstart", unlockAudio, { once: true });
      }
    };

    const timer = setTimeout(startVoice, 800);
    return () => clearTimeout(timer);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ─── LANGUAGE CHANGE : rejouer si pas coupé ───────────────────────────────
  useEffect(() => {
    if (!firstLoadRef.current) return;

    // Respecter la préférence persistée
    if (localStorage.getItem(MUTED_KEY) === "true") return;

    const timer = setTimeout(() => playLanguageAudio(), 300);
    return () => clearTimeout(timer);
  }, [i18n.language]); // eslint-disable-line react-hooks/exhaustive-deps

  // ─── Cleanup au démontage ─────────────────────────────────────────────────
  useEffect(() => {
    return () => stopAudio();
  }, []);

  // ─── Render ───────────────────────────────────────────────────────────────
  return (
    <div className="medilink-voice-bot">

      {/*
        UN SEUL BOUTON :
        - Audio en cours  → toggle mute/unmute
        - Audio arrêté    → lancer l'audio (si pas muted)
      */}
      <button
        type="button"
        className={`medilink-voice-bot__mic ${
          isPlaying && !isMuted
            ? "medilink-voice-bot__mic--active"
            : "medilink-voice-bot__mic--idle"
        }`}
        onClick={() => {
          if (isPlaying) {
            toggleMute(); // audio en cours → toggle mute
          } else {
            // audio arrêté → vérifier si l'user avait coupé
            if (isMuted) {
              // Réactiver et jouer
              toggleMute();
              setTimeout(() => playLanguageAudio(), 50);
            } else {
              playLanguageAudio();
            }
          }
        }}
        title={
          isMuted
            ? "Activer le son"
            : isPlaying
            ? "Couper le son"
            : "Lancer le son"
        }
      >
        {/* Anneaux pulsants quand actif et non muté */}
        {isPlaying && !isMuted && (
          <>
            <span className="medilink-voice-bot__pulse-ring" />
            <span className="medilink-voice-bot__pulse-ring medilink-voice-bot__pulse-ring--delay" />
          </>
        )}
        <MicIcon active={isPlaying && !isMuted} />
      </button>

    </div>
  );
}